import { render } from "./EditProfileInfo.vue?vue&type=template&id=25700496&scoped=true"
import script from "./EditProfileInfo.vue?vue&type=script&lang=js"
export * from "./EditProfileInfo.vue?vue&type=script&lang=js"

import "./EditProfileInfo.vue?vue&type=style&index=0&id=25700496&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25700496"]])

export default __exports__